// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__ochp4","label":"CategoryService_label__98ExF","location":"CategoryService_location__2ReIl"};